/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import type { PodMutatorStatusEnforcement } from './pod-mutator-status-enforcement';

/**
 * PodMutatorStatus represents the status of the pod mutator in the cluster.
 * @export
 * @interface PodMutatorStatus
 */
export interface PodMutatorStatus {
    /**
     * Enforcement feature status of the pod mutator.
     * @type {PodMutatorStatusEnforcement}
     * @memberof PodMutatorStatus
     */
    'enforcement'?: PodMutatorStatusEnforcement;
    /**
     * Status of the pod mutator
     * @type {string}
     * @memberof PodMutatorStatus
     */
    'status'?: PodMutatorStatusStatusEnum;
}

export const PodMutatorStatusStatusEnum = {
    STATUS_UNSPECIFIED: 'STATUS_UNSPECIFIED',
    INVALID: 'INVALID',
    RUNNING: 'RUNNING',
    DISABLED: 'DISABLED'
} as const;

export type PodMutatorStatusStatusEnum = typeof PodMutatorStatusStatusEnum[keyof typeof PodMutatorStatusStatusEnum];


